import React, { useEffect } from "react";
import { Route, withRouter, useLocation } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Error from "./pages/Error";
import NotFound from "./pages/NotFound";

const AppWrapper = (props: any) => {
  let location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  switch (props.location.pathname) {
    case "/login":
      return <Route path="/login" component={Login} />;
    case "/register":
      return <Route path="/register" component={Register} />;
    case "/forgot-password":
      return <Route path="/forgot-password" component={ForgotPassword} />;
    case "/reset-password":
      return <Route path="/reset-password" component={ResetPassword} />;

    case "/error":
      return <Route path="/error" component={Error} />;
    case "/notfound":
      return <Route path="/notfound" component={NotFound} />;

    case "/landing":
      return <Route path="/landing" component={Login} />;
    case "/":
      return <App />;
    default:
      return <App />;
  }
};

export default withRouter(AppWrapper);
